export const exportAsImage = async (imageUri: string, filename: string) => {
  const link = document.createElement('a');
  link.href = imageUri;
  link.download = filename;

  // Firefox requires the link to be in the body
  document.body.appendChild(link);

  // simulate click
  link.click();

  // remove the link when done
  document.body.removeChild(link);
  return Promise.resolve(link);
};

export const exportAsPdf = async (imageUri: string, filename: string) => {
  const jsPDFModule = await import(
    /* webpackChunkName: "jspdf" */
    /* webpackMode: "lazy" */
    'jspdf'
  );
  let positionTop = 5;
  const pdf = new jsPDFModule.default({ orientation: 'landscape' });
  const imgProps = pdf.getImageProperties(imageUri);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  let heightLeft = pdfHeight;
  pdf.addImage(imageUri, 'PNG', 0, positionTop, pdfWidth, pdfHeight);
  heightLeft -= pageHeight;
  while (heightLeft >= 0) {
    positionTop += heightLeft - pdfHeight; // top padding for other pages
    pdf.addPage();
    pdf.addImage(imageUri, 'PNG', 0, positionTop, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;
  }
  pdf.save(filename);
  return pdf;
};

const getCanvasFromHTML = async (element: HTMLElement) => {
  const html2canvas = (
    await import(
      /* webpackChunkName: "htmlToCanvas" */
      /* webpackMode: "lazy" */
      'html2canvas'
    )
  ).default;

  const imageCanvas = await html2canvas(element);
  return imageCanvas;
};

const copyCanvasToClipboard = (imageCanvas: HTMLCanvasElement, onCopy?: () => void) => {
  // Copy to clipboard
  imageCanvas.toBlob(async (blob) => {
    if (!blob) {
      console.error('Failed to create blob from canvas');
      return;
    }
    try {
      // Use the clipboard API to copy the image
      const clipboardItem = new ClipboardItem({ 'image/png': blob });
      await navigator.clipboard.write([clipboardItem]);
      onCopy?.();
      console.log('Image copied to clipboard');
    } catch (error) {
      console.error('Failed to copy image to clipboard:', error);
    }
  });
};

export const copyChartToClipboard = async (chartRef: React.RefObject<HTMLElement>, onCopy?: () => void) => {
  const element = chartRef.current;
  if (!element) {
    console.error('No element found');
    return;
  }
  const canvas = await getCanvasFromHTML(element);
  if (!canvas) {
    console.error('No canvas to copy');
    return;
  }
  copyCanvasToClipboard(canvas, onCopy);
};
